<div class="flex flex-col">
  <app-home-top class="z-9992" />
  <app-home-galery />
  <app-home-digits class="z-9993 relative" />
  <app-home-lets-meet class="z-9992" />
  <div class="z-9993 -mt-1 relative">
    <app-home-why class="" />
  </div>

  <div id="home-events">
    @defer (on viewport; prefetch on idle) {
      <app-home-events  class="z-9994" />
    } @placeholder {
      <div></div>
    }
  </div>

  <app-home-ambiance class="z-9993" />
  <app-home-program />

  <div class="z-9994 -mt-1 relative">
    @defer (on viewport; prefetch on idle) {
      <app-home-testimonies />
    } @placeholder {
      <div></div>
    }
  </div>

  @defer (on viewport; prefetch on idle) {
    <app-home-offers />
  } @placeholder {
    <div></div>
  }

  <app-home-faq />
  <div class="bg-white">
    <app-footer />
  </div>
</div>
